import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Logo11 from "../../images/location_new/caseimg/logo11.webp";
import Img11 from "../../images/location_new/caseimg/img11.webp";
import Logo12 from "../../images/location_new/caseimg/logo12.webp";
import Img12 from "../../images/location_new/caseimg/img12.webp";
import Logo13 from "../../images/location_new/caseimg/logo13.webp";
import Img13 from "../../images/location_new/caseimg/img13.webp";
import Logo8 from "../../images/location_new/caseimg/logo8.webp";
import Img8 from "../../images/location_new/caseimg/img8.webp";
import { Case_Arrow } from "../../../app-constants";
import { Link } from "gatsby";

const CaseStudy = [
  {
    logo: Logo8,
    title: "The Idea Behind Onsite Social",
    description:
      "OnSite Social, a TekRevol creation, bridges the physical and digital realms, forging meaningful real-time connections among users.",
    link: "onsite",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img8,
    BgColor: "#f3faff",
    TextColor: "#54a4c9",
  },
  {
    logo: Logo11,
    title: "The Idea Behind Button Smasher App",
    description:
      "An All-in-One Solution for Gamers. Stay Informed with Authentic Ratings and Gaming Industry News With Button Smasher Application.",
    link: "buttonsmasher",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img11,
    BgColor: "#6f429c80",
    TextColor: "#d8278b",
  },
  {
    logo: Logo12,
    title: "The Idea Behind AMJ Wellness",
    description:
      "Workplace Wellness, a cross-platform fitness app, is designed for companies recognizing the link between employee well-being, productivity, and organizational success, fostering a healthier and more productive workforce.",
    link: "amj-wellness",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img12,
    BgColor: "#eb374080",
    TextColor: "#c41728",
  },
  {
    logo: Logo13,
    title: "The Idea Behind Kush Me",
    description:
      "Kush-Me is a user-centric application that focuses on connecting individuals with nearby marijana dispensaries.",
    link: "kush-me",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img13,
    BgColor: "#c2e1c9",
    TextColor: "#43a84a",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>Success Stories</h2>
            </div>
            <p>
              Being rated among the top mobile app development companies in
              Indianapolis, we've collaborated with some visionary entrepreneurs
              for the creation of influential mobile app products. For that
              purpose, we utilized innovative technologies that fulfill the
              expectations of both businesses and their audiences. Now, we
              invite you with pleasure to explore the success stories that we
              have showcased below.
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>
                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
